import axios, { AxiosResponse } from "axios";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

export const createConsumer = async (
    requestBody:any
  ) => {
    try {
      const token = Cookies.get("access_token"); 
  
      const response: AxiosResponse = await apiClient.post(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/consumer`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      );
  
      return response.data;
    } catch (error) {
      console.error("Ошибка при создании системы получателя:", error);
      throw error;
    }
  };

export const updateConsumer = async (consumerId: number, data: any): Promise<any> => {
    try {
      const token = Cookies.get("access_token");
      const response: AxiosResponse<any> = await apiClient.put(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/consumer/${consumerId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении системы получателя:", error);
      throw error;
    }
  };
  
export const getConsumer =async(id:number)=>{
    try {
      const token = Cookies.get("access_token");
      const response =await apiClient.get (
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/consumer/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      )
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении системы получателя:", error);
      throw error;
    }
}

export const getGroupTNVED = async () => {
  try {
      const token = Cookies.get("access_token");
      const response = await apiClient.get(
          `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/dictionary/group-tnved`,
          {
              headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
              },
          }
      );
      return response.data;
  } catch (error) {
      console.error("Ошибка при получении списка групп ТН ВЭД:", error);
      throw error;
  }
};


export const unlinkConsumerFromTNVED = async (code: string, consumerId: number): Promise<any> => {
  try {
      const token = Cookies.get("access_token");
      const response: AxiosResponse<any> = await apiClient.post(
          `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/tnved/unlink`,
          { code, consumerId },
          {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
              },
          }
      );
      return response.data;
  } catch (error) {
      console.error("Ошибка при откреплении получателя от ТН ВЭД:", error);
      throw error;
  }
};


export const getCodeList =async(code = "")=>{
  try {
    const token = Cookies.get("access_token");
    const response =await apiClient.get (
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/tnved/${code}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      }
    )
    return response.data;
  } catch (error) {
    console.error("Ошибка при проверке кодов ТНВЭД:", error);
    throw error;
  }
}

export const getTNVDList =async(requestBody: any, page = 1, size = 10)=>{
  try {
    const token = Cookies.get("access_token");
    const response =await apiClient.post (
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/tnved/list`,
      requestBody,
      {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      }
    )
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении кодов ТНВЭД:", error);
    throw error;
  }
}

export const createTNVDCode = async (
  requestBody:any
) => {
  try {
    const token = Cookies.get("access_token"); 

    const response: AxiosResponse = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/tnved`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json", 
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при создании привязки получателя к ТНВЭД коду:", error);
    throw error;
  }
};

export const importTNVEDFromFile = async (
  file: File,
  consumerId: number,
  groupNameId?: number | null
) => {
  try {
    const token = Cookies.get("access_token");
    const formData = new FormData();
    formData.append("file", file);

    const params: { consumerId: number; groupNameId?: number } = { consumerId };
    if (groupNameId != null && groupNameId !== undefined) {
      params.groupNameId = groupNameId;
    }

    const response: AxiosResponse = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/tnved/import`,
      formData,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Ошибка при импорте привязок получателя к ТНВЭД из Excel:", error);
    throw error;
  }
};

